import * as z from 'zod';
import { ColorThemeEnum } from '@/enum/ColorThemeEnum';

const CTAZod = z.object({
  id: z.number(),
  label: z.string(),
  link: z.string(),
  color: z.enum([
    ColorThemeEnum.ORANGE,
    ColorThemeEnum.PURPLE,
    ColorThemeEnum.YELLOW,
    ColorThemeEnum.GREEN,
    ColorThemeEnum.WHITE,
  ]),
});

export { CTAZod };
export type CTAType = z.infer<typeof CTAZod>;
